import { Type1Dto  } from "@gtpl/shared-models/masters";
import { GlobalResponseObject } from '@gtpl/shared-models/common-models';

export class AllType1ResponseModel extends GlobalResponseObject{
    data?: Type1Dto[];
    /**
     * 
     * @param status 
     * @param errorCode 
     * @param internalMessage 
     * @param data //ProductDto
     */
    constructor(status: boolean, errorCode: number, internalMessage: string, data?: Type1Dto) {
        super(status, errorCode, internalMessage);
        // this.data = data;
    }
}
